import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import img1 from '../Img/user.png'
import img2 from '../Img/user.png'

const Onboarding = () => {
    const { isSidebarOpen } = useSidebar();

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [customers, setCustomers] = useState([
        {
            image: img1,
            details: 'John Doe',
            dob: '2000-01-15',
            standard: '10th Grade',
            center: 'ABC Institute',
            parentNo: '1234567890',
            status: 'Active'
        },
        {
            image: img2,
            details: 'Jane Smith',
            dob: '1999-11-25',
            standard: '12th Grade',
            center: 'XYZ Academy',
            parentNo: '9876543210',
            status: 'Inactive'
        },
    ]);
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = customers.filter((customer) =>
            Object.values(customer).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredCustomers(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, customers]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const currentData = filteredCustomers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handle Delete
    const handleDelete = (indexToDelete) => {
        const updatedCustomers = customers.filter((_, index) => index !== indexToDelete);
        setCustomers(updatedCustomers);
    };

    const toggleStatus = (indexToToggle) => {
        const updatedCustomers = customers.map((customer, index) =>
            index === indexToToggle
                ? { ...customer, status: customer.status === 'Active' ? 'Inactive' : 'Active' }
                : customer
        );
        setCustomers(updatedCustomers);
    };


    return (
        <>
         
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <h1 className="dashboard-title">Onboardings</h1>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Customer Table */}
                <div className="customer-table onboarding-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Details</th>
                                <th>DOB</th>
                                <th>Standard</th>
                                <th>Center Name</th>
                                <th>Parent No.</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td>
                                            <img
                                                src={customer.image}
                                                alt={customer.details}
                                                style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                                            />
                                        </td>
                                        <td>{customer.details}</td>
                                        <td>{customer.dob}</td>
                                        <td>{customer.standard}</td>
                                        <td>{customer.center}</td>
                                        <td>{customer.parentNo}</td>
                                        <td>{customer.status}</td>
                                        <td>
                                            <button
                                                className={`toggle-button onboarding-check ${customer.status === 'Active' ? 'active-status' : 'inactive-status'}`}
                                                onClick={() => toggleStatus(index)}
                                            >
                                                <i className="fas fa-check"></i>
                                            </button>

                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center' }}>No records found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>
        </>
    );
};

export default Onboarding;
